import { render, staticRenderFns } from "./TopUpBalance.vue?vue&type=template&id=845492d4&"
import script from "./TopUpBalance.vue?vue&type=script&lang=ts&"
export * from "./TopUpBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports